export default "__VITE_ASSET__4cb0db4d__"